export const truncateNumber = (number: number) =>
  Math.trunc(number * 100) / 100;
